<script setup lang="ts">
import type { NavigationBarAction } from '../navigation-bar';
import HugeIcon from '../../HugeIcon/HugeIcon.vue';
import TTooltip from '../../TTooltip.vue';

const props = defineProps<{
  item: NavigationBarAction;
  compact: boolean;
}>();
</script>

<template>
  <TTooltip
    :content="props.compact ? props.item.label : null"
    placement="right"
    class="flex w-full items-center justify-center"
  >
    <button
      class="text-primary-500 flex w-full cursor-pointer items-center text-left text-xs font-bold transition-all"
      :class="[
        props.compact
          ? 'h-10 min-h-10 w-10 min-w-10 items-center justify-center rounded-md p-2 hover:bg-white hover:shadow-sm'
          : 'hover:translate-x-1',
      ]"
      @click="props.item.onClick"
    >
      <div>
        <HugeIcon
          :icon="props.item.icon"
          :class="[props.compact ? 'mr-0' : 'mr-2']"
          :size="20"
        />
      </div>
      <div
        class="truncate transition-all duration-200 ease-out"
        :class="[props.compact ? 'h-0 w-0 opacity-0' : 'w-full opacity-100']"
      >
        {{ props.item.label }}
      </div>
    </button>
  </TTooltip>
</template>
